import React, { FC, useEffect, useState } from 'react'
import schipt_logo from '../../assets/Schipt_black.png';
import schipt_logo_white from '../../assets/Schipt_white.png';
import { Link, useLocation, useNavigate } from "react-router-dom"
import "../../assets/style/Navbar.css"
import { useTranslate, useStaticData, useWebSocket } from "../../hooks"
import '../../assets/flags/flags.css'
import { useAuth } from '../../hooks'
import { FaCircleCheck, FaCircleInfo, FaCircleXmark, FaShare, FaTriangleExclamation } from 'react-icons/fa6';
import { PiBellRingingFill, PiBellFill } from 'react-icons/pi';
import { WebSocketSubscribeMessageType } from '../../types';
import { deepCopyOf, dialog, logger } from '../../utils';
import TourStepper from '../Surfaces/TourStepper';

type Props = {
  children?: JSX.Element | JSX.Element[]
}

type NavbarItem_Props = {
  children: JSX.Element | JSX.Element[],
  name: string | React.ReactNode,
  open?: boolean,
  id?: string
}

type notificationsType = WebSocketSubscribeMessageType & { unRead?: false };

const Navbar: FC<Props> = ({ children }) => {
  const { roleAccess } = useAuth()
  const { t, theme } = useTranslate()
  const [showMobileMenu, setShowMobileMenu] = useState(false)
  const { staticData } = useStaticData()
  const location = useLocation();
  const navigate = useNavigate()
  const ws = useWebSocket()
  const [ notifications, setNotifications ] = useState<notificationsType[]>([])
  const [ hideTour, setHideTour ] = useState(localStorage.hideTour);

  useEffect(() => {
    const unsubscribe = ws.subscribe((message: WebSocketSubscribeMessageType) => {
      if(message.type === "confirm") return dialog.open({message: {type: "info", name: message.message}}, {title: message.title, hideCancelButton:true})
      setNotifications(cur => {cur.unshift(message); return cur})
    })

    return () => unsubscribe();
  }, [ws.subscribe])

  useEffect(() => {
    if(!staticData?.notifications || staticData.notifications.length === 0) 
      return
    setNotifications(deepCopyOf(staticData.notifications))
  }, [staticData])

  const NavbarItem: FC<NavbarItem_Props> = ({ children, name, open, id }) => {
    const [showMe, setShowMe] = useState(open)

    return <li className={`schipt-navbar-item ${showMe ? 'active' : ''}`}
      onMouseEnter={() => setShowMe(true)}
      onMouseLeave={() => setShowMe(false)}
    >
      {name}
      <div id={id}>
        {children}
      </div>
    </li>
  }

  const closeMobileMenu = (e: any) => {
    try {
      setShowMobileMenu(false)
      //document.querySelector('.schipt-navbar input')?.attributes?.removeNamedItem?.('checked')
    } catch (e) {
      console.log({ e })
    }
  }

  return (<>
    <nav className='schipt-navbar relative z-1'>
      <ul className='left inline-flex'>
        <li>
          <Link to="/shipments">
            <img src={theme === 'dark' ? schipt_logo_white : schipt_logo} alt="logo" className='schipt-logo' />
            {staticData?.warehouse.testMode  && 
              <div style={{fontSize:"1.5rem"}}
                title={t("testModeHover")}
                className='animate-pulse text-red-500'
              >{t("testMode")}</div>
            }
          </Link>
        </li>
        <div className='flex content-center justify-center flex-wrap ml-5 cursor-help' title={t("yourCompanyId")}>
          <p style={{textAlign:"center", opacity:.5}}>{staticData?.companyId}</p>
        </div>
      </ul>
      <ul className="center">
        <li>
          <Link to="/Shipments" id="navbar-shipments">{t("shipments")}</Link>
        </li>
        <NavbarItem name={t("settings")} id="navbar-settings">
          <Link to="/Carriers" id="navbar-carriers">{t("carriers")}</Link>
          <Link to="/DeliveryTypes" id="navbar-deliverytypes">{t("deliveryTypes")}</Link>
          <Link to="/Addresses" id="navbar-addresses">{t("addresses")}</Link>
        </NavbarItem> 
        <NavbarItem name={t("support")} id="navbar-support">
          <Link to="/shipments" onClick={(e) => {
            localStorage.removeItem("hideTour");
            navigate("/shipments")
            setTimeout(() => window.location.reload())            
          }}>{t("rerunTour")}</Link>
          <Link to={t('Faq_link')} onClick={closeMobileMenu} target='_blank' rel='noreferrer'>{t("Faq")}</Link>
          <Link to={t('schipt_useragreement_link')} onClick={closeMobileMenu} target='_blank' rel='noreferrer'>{t('schipt_useragreement_linktext')}</Link>
        </NavbarItem>
      </ul>
      <ul className='right'>        
        <NavbarItem name={notifications.some(n => n.unRead !== false) ? <PiBellRingingFill size={"1.2rem"} color="hsl(0, 80%, 50%)" className='notifications-unread-messages'/> : <PiBellFill size={"1.2rem"}/>} id="notifications">
            <div style={{maxHeight: "15rem", maxWidth:"15rem", overflowX: "clip", overflowY:"scroll"}}>
              {notifications.map((n, i) => {

                const unReadClass = n.unRead !== false ? " unRead": ""
                const textCroppedClass = n.message.length > 120 ? " cropped-xl" 
                  : n.message.length > 45 ? " cropped-l" 
                  : ""

                return <div className={`p-2 relative w-full flex flex-col h-16${unReadClass}${textCroppedClass}`}
                  onClick={(e:React.MouseEvent<HTMLDivElement, MouseEvent>) => {
                    if(e.currentTarget.classList.contains("unRead")){
                      e.currentTarget.classList.remove("unRead")
                      const notifs = deepCopyOf(notifications)
                      notifs[i].unRead = false
                      setNotifications(notifs)
                    }
                    if(n.shipmentId && location.pathname != `/Shipment/${n.shipmentId}`){
                      return navigate(`Shipment/${n.shipmentId}`, {state:{delayTime: (new Date).getTime() + 500}})
                    }
                    
                    if(e.currentTarget.classList.contains("cropped-xl")){
                      dialog.open({message:{type:"info", name: n.message}}, {title:n.title, hideCancelButton:true})
                    }else if (e.currentTarget.classList.contains("cropped-l")) {
                      e.currentTarget.classList.remove("h-16")
                    }                    
                  }}
                >
                  {n.shipmentId && <FaShare className='isRedirect'/>}
                  <div className='flex'>
                    {
                      n.type === "error" ? <FaCircleXmark color='tomato'/> :
                      n.type === "warning" ? <FaTriangleExclamation color="Darkgoldenrod"/> :
                      n.type === "info" ? <FaCircleInfo color='dodgerblue' /> :
                      n.type === "success" ? <FaCircleCheck color="forestgreen"/> : <></>
                    }
                    <span className='ml-2'>{n.title}</span>
                  </div>
                  <div className='w-full h-full overflow-hidden'>{n.message}</div>
                </div>
              })}
            </div>
            {notifications.length === 0 ? <></> : 
              <div className='flex'>
                <div className='text-2 markAsRead' onClick={() => {
                    const notifs = deepCopyOf(notifications)
                    notifs.map(n => n.unRead = false)
                    setNotifications(notifs)
                  }}
                >{t("markAllAsRead")}</div>
                <div className='text-2 markAsRead' onClick={() => {
                    setNotifications([])
                  }}
                >{t("deleteAll")}</div>
              </div>
            }
                        
        </NavbarItem>
        <NavbarItem name={t("account.myAccount")}>
          <Link to="/MyProfile" id="navbar-profile">{t("account.profile")}</Link>
          {roleAccess?.(["SuperUser", "Moderator"]) ? (
            <>
              <Link to="/Subscription" id="navbar-subscription">{t("account.subscription")}</Link>
              <Link to="/Users" id="navbar-users">{t("account.userAdministration")}</Link>
            </>
          ) : (
            <></>
          )}
          <Link to='/Logout'>{t("account.logout")}</Link>
        </NavbarItem>
      </ul>
      <div className='mobile'>
        <input type="checkbox" checked={showMobileMenu} onChange={() => setShowMobileMenu(v => !v)} />
        {/* Some spans to act as a hamburger. */}
        <span></span>
        <span></span>
        <span></span>
        <ul className='menu'>
          <li className="hover:bg-schipt-dark-gray dark:hover:bg-schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
            <Link to="/Shipments" onClick={closeMobileMenu}>{t("shipments")}</Link>
          </li>
          <li>
            <p>{t("settings")}</p>
            <ul>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to="/Carriers" onClick={closeMobileMenu}>{t("carriers")}</Link>
              </li>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to="/DeliveryTypes" onClick={closeMobileMenu}>{t("deliveryTypes")}</Link>
              </li>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to="/Addresses" onClick={closeMobileMenu}>{t("addresses")}</Link>
              </li>
            </ul>
          </li>
          <li>
            <p>{t("account.myAccount")}</p>
            <ul>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to="/MyProfile" onClick={closeMobileMenu}>{t("account.profile")}</Link>
              </li>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to="/Subscription" onClick={closeMobileMenu}>{t("account.subscription")}</Link>
              </li>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to="/Users" onClick={closeMobileMenu}>{t("account.userAdministration")}</Link>
              </li>
            </ul>
          </li>

          <li>
            <p>{t("support")}</p>
            <ul>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
               <Link to="/shipments" onClick={(e) => {localStorage.setItem("hideTour", "0"); closeMobileMenu(e);}}>
                 {t("rerunTour")}
               </Link>
              </li>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to={t('Faq_link')} onClick={closeMobileMenu} target='_blank' rel='noreferrer'>{t("Faq")}</Link>
              </li>
              <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
                <Link to={t('schipt_useragreement_link')} onClick={closeMobileMenu} target='_blank' rel='noreferrer'>{t('schipt_useragreement_linktext')}</Link>
              </li>
            </ul>
          </li>

          <li className="pl-3 hover:bg-schipt-dark-gray dark:hover:schipt-darkest hover:bg-opacity-10 dark:hover:bg-opacity-100 dark:text-schipt-white-90">
            <Link to="/Logout" onClick={closeMobileMenu}>{t("account.logout")}</Link>
          </li>
        </ul>
      </div>
    </nav>
    { staticData?.warehouse &&
      <TourStepper 
        hide={hideTour === "1"}
        startingStep={location.pathname === "/Subscription" ? 1 : 0}
        onEnd={() => {
          localStorage.setItem("hideTour", "1")
          setHideTour("1")
        }}
        tourSteps={[
        {id:null, header:t("tour.welcomeHeader"), text:t("tour.welcome"),
          onNext: () => document.querySelector("li:has(#navbar-subscription)")?.classList.add("active"), 
        },
        {id:"navbar-subscription", header:t("tour.moderator.activateCarriersHeader"), text:t("tour.moderator.activateCarriers"), orientation:"left",
          onNext: () => {
            document.querySelector("li:has(#navbar-subscription)")?.classList.remove("active")
            document.querySelector("li:has(#navbar-carriers)")?.classList.add("active")
          },
          onBack: () => document.querySelector("li:has(#navbar-subscription)")?.classList.add("active"),
        },
        {id:"navbar-carriers", header:t("tour.moderator.createCarrierHeader"), text:t("tour.moderator.createCarrier"),
          onBack: () => {
            document.querySelector("li:has(#navbar-subscription)")?.classList.add("active") 
            document.querySelector("li:has(#navbar-carriers)")?.classList.remove("active") 
          }
        },
        {id:"navbar-deliverytypes", header:t("tour.moderator.createDeliveryTypeHeader"), text:t("tour.moderator.createDeliveryType") 
        },
        {id:"navbar-addresses", header:t("tour.moderator.createAddressHeader"), text:t("tour.moderator.createAddress"),
          onNext: () => {
            document.querySelector("li:has(#navbar-carriers)")?.classList.remove("active")
            document.querySelector("li:has(#navbar-profile)")?.classList.add("active")
          },           
        },
        {id:"navbar-profile", header:t("tour.moderator.profileHeader"), text:t("tour.moderator.profile"), orientation:"left",
          onBack: () => {
            document.querySelector("li:has(#navbar-carriers)")?.classList.add("active")
            document.querySelector("li:has(#navbar-profile)")?.classList.remove("active")
          }, 
        },
        {id:"navbar-users", header:t("tour.moderator.usersHeader"), text:t("tour.moderator.users"), orientation:"left",
          onNext: () => document.querySelector("li:has(#navbar-profile)")?.classList.remove("active"), 
          onBack: () => document.querySelector("li:has(#navbar-profile)")?.classList.add("active"), 
        },
        {id:"navbar-shipments", header:t("tour.createShipmentHeader"), text:t("tour.createShipment")
        },
        {id:null, header:t("tour.endHeader"), text:t("tour.end")
        }
      ]}/>
    }
    
    {children}
  </>
  )
}

export default Navbar